import Vue from 'vue'
import vuex from 'vuex'
import gisData from './DigitalGIS'

// 有使用到vuex的引入modules下的js

Vue.use(vuex);

export default new vuex.Store({
    modules: {
        gisData: gisData
    }
});